import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { CallClearCart, chain } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";

addToChainAfter(chain, CallClearCart, async props => {
    // Verndale Customization ticket: DSSM-465
    const products = props.getState().data.carts.byId[props.apiParameter.cartId].cartLines;

    const result = await getProductCategories({
        productIds: [...products!.map(cl => cl.productId!)],
        type: "product",
    });

    if (result.successful) {
        const productCategories = result.result;
        const currentPath = window.location.pathname;
        if (currentPath === "/Cart") {
            setGA4Event([...products!], "remove_from_cart", {productCategories});
        }
    }
    // End of Verndale Customization ticket: DSSM-469
});
